import { Tooltip as AntTooltip, TooltipProps as AntTooltipProps } from 'antd';
import React from 'react';
import { theme } from '../../theme/semanticTokens';

export type TooltipPlacement =
  | 'top'
  | 'topLeft'
  | 'topRight'
  | 'left'
  | 'leftTop'
  | 'leftBottom'
  | 'right'
  | 'rightTop'
  | 'rightBottom'
  | 'bottom'
  | 'bottomLeft'
  | 'bottomRight';

export interface TooltipProps
  extends Omit<AntTooltipProps, 'placement' | 'title'> {
  title: React.ReactNode;
  placement?: TooltipPlacement;
  children: React.ReactNode;
  className?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({
  title,
  placement = 'top',
  children,
  className = '',
  ...props
}) => {
  return (
    <AntTooltip
      title={title}
      placement={placement}
      className={className}
      arrow
      overlayInnerStyle={{
        backgroundColor: theme.dime.colors.fill.inverse,
        color: theme.dime.colors.text.inverse,
        borderRadius: theme.dime.radius.s,
        padding: theme.dime.spacing.m,
        maxWidth: '320px',
        lineHeight: '22px',
        boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.08)'
      }}
      color={theme.dime.colors.fill.inverse}
      {...props}
    >
      {children}
    </AntTooltip>
  );
};
